module.exports = __webpack_public_path__ + "static/media/trash_selected.0db1b9e5.svg";